import "./TicketPill.scss";

export const TicketPillSkeleton = () => (
  <div className="ticket-pill skeleton">
    <span className="ticket-id skeleton-text" />
    <div className="sold-info">
      <span className="sold-date skeleton-text" />
      <span className="sold-by skeleton-text" />
    </div>
  </div>
);
